import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPatientTherapies(
  patientId: string | undefined,
  protocolIds?: string[],
  hideIsolated?: boolean,
  hidePrevious?: boolean
) {
  return useQuery(
    queries.patients.getPatientTherapies({
      patientId: patientId || '',
      protocolIds: protocolIds,
      hideIsolated: hideIsolated,
      hidePrevious: hidePrevious,
    })
  )
}
